export default "__VITE_ASSET__d258036b__"